export default class Image {
  raw = undefined
  id = undefined
  url = undefined
  permalink = undefined
  api_url = undefined

  constructor (source = undefined) {
    this.raw = source
    if(source) {
      this.parseSource(source)
    }
  }

  parseSource (source) {
    for (const prop in source) {
      if (prop in this) {
        this[prop] = source[prop]
      }
    }
  }

  src () {
    console.log('src() ', this)
    return this.url
  }

  hasImage () {
    console.log('hasImage()', !!this.url)
    return !!this.url
  }

}
